import React from 'react'
import css from './style.css'

const TopSectionContainer = props => (
  <div className={css.topSectionContainer}>
    {props.children}
  </div>
)

export default TopSectionContainer



// WEBPACK FOOTER //
// ./src/components/search-results/top-section-container.js